import Backbone from "backbone";
import EsResult from "models/esResult";

class EsResults extends Backbone.Collection {}

EsResults.prototype.model = EsResult;

export default EsResults;
